import React, { Component } from "react";
import PropTypes from "prop-types";
import { Table, Pagination, Dropdown } from "semantic-ui-react";
import { ActivityLogItem } from "@modules/AuditLogs/CatalogLogging/ActivityLogItem";

export class ActivityLogList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      itemsPerPage: 20,
      pageSizeOptions: [
        { key: 10, text: "10 per page", value: 10 },
        { key: 20, text: "20 per page", value: 20 },
        { key: 50, text: "50 per page", value: 50 },
        { key: 100, text: "100 per page", value: 100 },
      ],
    };
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
  };

  handleItemsPerPageChange = (e, { value }) => {
    const parsedValue = parseInt(value, 10);
    if (parsedValue > 0 && parsedValue <= 1000) {
      this.setState({
        itemsPerPage: parsedValue,
        activePage: 1, // Reset to first page when changing page size
      });
    }
  };

  handleAddition = (e, { value }) => {
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue) && parsedValue > 0 && parsedValue <= 1000) {
      this.setState((prevState) => ({
        pageSizeOptions: [
          ...prevState.pageSizeOptions,
          {
            key: parsedValue,
            text: `${parsedValue} per page`,
            value: parsedValue,
          },
        ],
        itemsPerPage: parsedValue,
        activePage: 1,
      }));
    }
  };

  render() {
    const { auditLogs = [] } = this.props;
    const { activePage, itemsPerPage, pageSizeOptions } = this.state;

    if (auditLogs.length === 0) {
      return null;
    }

    // Calculate pagination
    const totalPages = Math.ceil(auditLogs.length / itemsPerPage);
    const startIndex = (activePage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentLogs = auditLogs.slice(startIndex, endIndex);

    const paginationSection = (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div style={{ color: "#666" }}>
            Showing {startIndex + 1} - {Math.min(endIndex, auditLogs.length)} of{" "}
            {auditLogs.length} logs
          </div>

          {totalPages > 1 && (
            <Pagination
              activePage={activePage}
              totalPages={totalPages}
              onPageChange={this.handlePaginationChange}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
            />
          )}

          <Dropdown
            selection
            compact
            search
            allowAdditions
            additionLabel="Custom: "
            options={pageSizeOptions}
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            onAddItem={this.handleAddition}
            placeholder="Items per page"
          />
        </div>
      </div>
    );

    return (
      <div>
        <div style={{ marginTop: "1px" }}>{paginationSection}</div>
        <Table celled striped selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center">
                Date & Time
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">User</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Document</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Details</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {currentLogs.map((log, index) => (
              <ActivityLogItem
                key={log.id || `audit-log-${index}`}
                auditLog={log}
              />
            ))}
          </Table.Body>
        </Table>
        <div style={{ marginTop: "20px" }}>{paginationSection}</div>
      </div>
    );
  }
}

ActivityLogList.propTypes = {
  auditLogs: PropTypes.array,
};

ActivityLogList.defaultProps = {
  auditLogs: [],
};
